import { useTranslation } from 'react-i18next';
import { Hourglass } from '@phosphor-icons/react';
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui-kit/empty';
import { SoonBadge } from '../soon-badge/soon-badge';

/**
 * A tab or section on the navigation map that is not built yet (Component Map › Soon placeholders:
 * `empty` + a Soon badge), e.g. Dinner on the Meal pages. `name` is its translation key.
 */
export const SoonPanel = ({ name }: { name: string }) => {
  const { t } = useTranslation();
  return (
    <Empty className="border-y py-12">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Hourglass />
        </EmptyMedia>
        <SoonBadge />
        <EmptyTitle>{t(name)}</EmptyTitle>
        <EmptyDescription>{t('SOON_PAGE_DESCRIPTION')}</EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
};
